import React from 'react';
import { LayoutProps, SpaceProps } from 'styled-system';

import { Content } from './styles';

export type PropTypes = {
  children: React.ReactNode;
  borderLeft?: boolean;
  reverse?: boolean;
} & SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

const BlockCard = ({ children, borderLeft = true, reverse, ...props }: PropTypes): JSX.Element => (
  <Content {...props} borderLeft={borderLeft} reverse={reverse}>
    {children}
  </Content>
);

export default BlockCard;
